import { CheckIcon, XIcon } from 'lucide-react'
import React from 'react'

import { cn } from './cn'

interface FeatureListProps {
  className?: string
  children?: React.ReactNode
}

interface FeatureListItemProps extends FeatureListProps {
  title?: string | React.ReactNode
  titleClassName?: string
  type?: 'default' | 'con'
}

export const FeatureList = ({ className, children }: FeatureListProps): React.ReactElement => {
  return <ul className={cn('snplay:space-y-4', className)}>{children}</ul>
}

export const FeatureListItem = ({
  title,
  className,
  titleClassName,
  type = 'default',
  children,
}: FeatureListItemProps): React.ReactElement => {
  return (
    <li className={className}>
      <div className="snplay:relative snplay:pl-12">
        <span
          className={cn(
            'snplay:absolute snplay:top-0 snplay:left-0 snplay:rounded-full',
            'snplay:bg-primary snplay:p-2 snplay:shadow-md snplay:shadow-primary/25',
            type === 'con' && 'snplay:bg-destructive snplay:shadow-destructive/25',
          )}
        >
          {type === 'con' ? (
            <XIcon className="snplay:size-4 snplay:text-ui-foreground" />
          ) : (
            <CheckIcon className="snplay:size-4 snplay:text-ui-foreground" />
          )}
        </span>
        {title && (
          <h2 className={cn('snplay:py-1 snplay:text-xl snplay:font-bold', titleClassName)}>
            {title}
          </h2>
        )}
        <div className="snplay:text-ui-secondary">{children}</div>
      </div>
    </li>
  )
}
